export const lightTheme = {
  type: "light",
  body: "#FFF",
  text: "#000",
  toggleBorder: "#FFF",
  background: "#363537",
  primaryColor: "#678",
  secondaryColor: "#678",
  tertiaryColor: "#fff",
  primaryFont: "Concert One",
  secondaryFont: "Meera Inimai",
}
export const darkTheme = {
  type: "dark",
  body: "#000",
  text: "#ddd",
  toggleBorder: "#6B8096",
  background: "#999",
  primaryColor: "#2d8180",
  secondaryColor: "#2d8180",
  tertiaryColor: "#123",
  primaryFont: "Concert One",
  secondaryFont: "Meera Inimai",
}
